export default __webpack_public_path__ + "static/media/01.40667d53.png";